import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  DataLicense,
  FileResource,
  Submission,
  SubmissionControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { submissionWorkflowConfig } from "../../../environments/environment";
import { LoggingService, LogLevel } from "../../_services/logging.service";
import { NotificationService } from "../../_services/notification.service";
import { CardModule } from "primeng/card";
import { SelectModule } from "primeng/select";
import { ButtonGroupModule } from "primeng/buttongroup";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { TableModule } from "primeng/table";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-upload",
  templateUrl: "./upload.component.html",
  styleUrls: ["./upload.component.scss"],
  standalone: true,
  imports: [
    ButtonModule,
    ButtonGroupModule,
    CardModule,
    CommonModule,
    SelectModule,
    FormsModule,
    TableModule,
    TranslateModule
  ]
})
export class UploadComponent implements OnInit {
  private submissionService = inject(SubmissionControllerService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private loggingService = inject(LoggingService);

  submissionId: string | undefined;
  activeIndex: number = 2;
  submission: Submission | undefined;
  dataLicenses: DataLicense[] | undefined;
  dataLicense: DataLicense | undefined;
  file: File | undefined = undefined;
  public progress: boolean = false;

  ngOnInit() {
    this.submissionId = this.route.snapshot.params.id;
    if (this.submissionId) {
      this.submissionService.submissionGetById(this.submissionId).subscribe(result => {
        this.submission = <Submission>result;
        if (this.submission?.study?.dataLicense) {
          this.dataLicense = this.submission.study.dataLicense;
        }
      });
      this.submissionService.submissionGetDataLicenses().subscribe(result => {
        this.dataLicenses = result?._embedded?.dataLicenses || [];
      });
    }
  }

  clear() {
    this.file = undefined;
  }

  onSelectFile(event: any) {
    this.loggingService.log(
      "UploadComponent",
      "onSelectFile: " + JSON.stringify(event),
      LogLevel.DEBUG
    );
    const file: File = event.target.files[0];
    if (file) {
      this.loggingService.log(
        "UploadComponent",
        "Setting file: " + JSON.stringify(file.name),
        LogLevel.DEBUG
      );
      this.file = file;
    }
  }

  deleteFile(file: FileResource) {
    this.loggingService.log(
      "UploadComponent",
      "deleteFile: " + JSON.stringify(file),
      LogLevel.DEBUG
    );
    if (this.submissionId) {
      this.submissionService
        .submissionDeleteFile(this.submissionId, file)
        .subscribe(result => {
          this.loggingService.log(
            "UploadComponent",
            "Received response: " + JSON.stringify(result),
            LogLevel.DEBUG
          );
          this.submission = result;
        });
    }
  }

  myCustomUpload(event: any) {
    this.loggingService.log(
      "UploadComponent",
      "myCustomUpload: " + JSON.stringify(event),
      LogLevel.DEBUG
    );
    if (this.file) {
      this.loggingService.log(
        "UploadComponent",
        "File is populated",
        LogLevel.DEBUG
      );
      this.progress = true;
      this.loggingService.log(
        "UploadComponent",
        "Using data license: " + JSON.stringify(this.dataLicense),
        LogLevel.DEBUG
      );
      if (this.submissionId && this.dataLicense) {
        this.submissionService
          .submissionUpload(this.submissionId, this.dataLicense, this.file)
          .subscribe(
            response => {
              this.loggingService.log(
                "UploadComponent",
                "Received response: " + JSON.stringify(response),
                LogLevel.DEBUG
              );
              this.submission = response;
              this.file = undefined;
              this.dataLicense = undefined;
              this.progress = false;
            },
            error => {
              this.loggingService.log(
                "UploadComponent",
                "Received error response: " + JSON.stringify(error),
                LogLevel.DEBUG
              );
              this.progress = false;
              this.notificationService.publish(
                "messages",
                "error",
                "Error",
                JSON.stringify(error)
              );
            }
          );
      } else {
        this.loggingService.log(
          "UploadComponent",
          "No submission ID or data licensefound",
          LogLevel.DEBUG
        );
      }
    } else {
      this.loggingService.log(
        "UploadComponent",
        "FileForm is not populated",
        LogLevel.DEBUG
      );
    }
    return;
  }

  isFormValid(): boolean {
    var inputOk = this.isFileSelectionValid() && this.isLicenseValid();
    return inputOk; // && !this.fileExists();
  }

  isFileSelectionValid(): boolean {
    return this.file != null;
  }

  isLicenseValid(): boolean {
    this.loggingService.log(
      "UploadComponent",
      "isLicenseValid: " + JSON.stringify(this.dataLicense),
      LogLevel.DEBUG
    );
    return this.dataLicense != null;
  }

  fileExists(): boolean {
    return (
      this.submission?.submittedFiles?.some(
        value => value.fileName === this.file?.name
      ) || false
    );
  }

  getFormInputValidClasses() {
    if (this.isFormValid()) {
      return {};
    } else {
      return {
        "ng-invalid": true,
        "ng-dirty": true
      };
    }
  }

  hasMzTabFiles(): boolean {
    return (
      this.submission?.submittedFiles?.some(
        value => value.fileType === "MZTAB_M"
      ) || false
    );
  }

  nextPage(event: any) {
    this.loggingService.log(
      "UploadComponent",
      "nextPage: " + JSON.stringify(event),
      LogLevel.DEBUG
    );
    this.router.navigate(
      [
        submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex]
          .routerLink,
        this.submissionId
      ],
      { relativeTo: this.route.parent }
    );
    return;
  }

  previousPage(event: any) {
    this.loggingService.log(
      "UploadComponent",
      "previousPage: " + JSON.stringify(event),
      LogLevel.DEBUG
    );
    if (this.activeIndex > 1) {
      this.loggingService.log(
        "UploadComponent",
        "previousPage via activeIndex: " +
          JSON.stringify([
            submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex - 2]
              .routerLink,
            this.submissionId
          ]),
        LogLevel.DEBUG
      );
      this.loggingService.log(
        "UploadComponent",
        "Active index: " +
          (this.activeIndex - 2) +
          " is " +
          JSON.stringify(
            submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex - 2]
              .routerLink
          ),
        LogLevel.DEBUG
      );
      this.router.navigate(
        [
          submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex - 2]
            .routerLink,
          this.submissionId
        ],
        { relativeTo: this.route.parent }
      );
    } else {
      this.loggingService.log(
        "UploadComponent",
        "previousPage to parent: " + JSON.stringify([this.route.parent]),
        LogLevel.DEBUG
      );
      this.router.navigate(submissionWorkflowConfig.parentRoute);
    }
    return;
  }

  cancel(event: any) {
    this.router.navigate(submissionWorkflowConfig.parentRoute);
    return;
  }
}
